import{useEffect as e,useState as t}from"react";var r=r=>{const[s,u]=t(r);return e(()=>{const e=setTimeout(()=>{u(r)},500);return()=>clearTimeout(e)},[r]),s};export{r as useDebouncedValue};
//# sourceMappingURL=useDebouncedValue.js.map